<script lang="ts" setup>
import {computed, defineOptions} from 'vue';

defineOptions({
	name: 'Loader'
});
const sizes: Record<string, string> = {
	s: '40px',
	m: '48px',
	l: '56px',
};

type LoaderSize = typeof sizes[number];

const props = withDefaults(
		defineProps<{
			text?: string;
			size?: LoaderSize;
		}>(),
		{
			text: '',
			size: 'm'
		}
);

const borderWidth = computed(
	() => {
    const sizePx = parseFloat(sizes[props.size]);
    return sizePx * 0.13 + 'px';
	}
);

</script>

<template>
	<div class="spinner-overlay" :style="{
		'--loader-size': sizes[props.size]
		, '--loader-border-size': borderWidth
	}">
		<div class="spinner"></div>
		<div v-if="text" class="loading-text">{{ text }}</div>
	</div>
</template>

<style scoped>
:root {
	--loader-size: 32px;
	--loader-border-size: 5px;
}
.spinner-overlay {
  background-color: #00000006;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	z-index: 9999;
}

.spinner {
	border: var(--loader-border-size) solid lightgrey;
	width: var(--loader-size);
	min-width: var(--loader-size);
	height: var(--loader-size);
	min-height: var(--loader-size);
	border-radius: 50%;
	border-left-color: #008800;

	animation: spin 1s ease-in-out infinite;
}

.loading-text {
	color: #333;
	font-size: 1.1rem;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>